import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { debounce } from 'lodash';

import EventTime from '@xanadu/ui-shared/components/event/EventTime';

import { PRODUCT_ROUTES } from '../../../../../constants';

import EventName from '../../../EventName';
import SVGIcon from '../../../../widgets/SVGIcon';

import styles from './RelatedEvent.module.scss';

const vs = str => <strong className={styles.vs}>{str}</strong>;
const home = str => <span className={styles.home}>{str}</span>;
const away = str => <span className={styles.away}>{str}</span>;

const RelatedEvent = ({
  onEventClose,
  subscribeToEvent,
  unsubscribeToEvent,
  selectedEvent,
  product,
  event
}) => {
  const subscribe = useMemo(() => debounce(eventId => subscribeToEvent(eventId), 300), []);
  const unsubscribe = useMemo(() => debounce(eventId => unsubscribeToEvent(eventId), 300), []);

  const productUrlPrefix = PRODUCT_ROUTES[product];

  useEffect(() => {
    subscribe(event.id);

    return () => {
      unsubscribe(event.id);
    };
  }, [event.id]);

  useEffect(() => {
    if (event.status === 'closed') {
      onEventClose();
    }
  }, [event.status]);

  if (event.status === 'closed') {
    return null;
  }

  return (
    <li className={styles.main}>
      <Link
        className={`${styles.link} ${selectedEvent === event.id && styles.selected}`}
        to={`${productUrlPrefix}/events/${event.id}`}
      >
        <span className={styles.startTime}>
          {event.start && (
            <EventTime
              start={event.start}
              scoresPhase={event.scores.phase}
              scoresHome={event.scores.home}
              scoresAway={event.scores.away}
              scoresType={event.scores.type}
              scoresElapsedTimeMinutes={event.scores.elapsedTimeMinutes}
              status={event.status}
              inRunningFlag={event.inRunningFlag}
            />
          )}
        </span>
        <span className={styles.name}>
          <EventName vs={vs} home={home} away={away}>
            {event.name}
          </EventName>
        </span>
        {event.allowLiveBetting && (
          <span className={styles.inPlay}>
            <SVGIcon
              className={`${styles.icon} ${event.inRunningFlag && styles.inPlay}`}
              name="liveBetting"
            />
          </span>
        )}
      </Link>
    </li>
  );
};

RelatedEvent.propTypes = {
  selectedEvent: PropTypes.string,
  event: PropTypes.instanceOf(Object),
  product: PropTypes.string.isRequired,
  subscribeToEvent: PropTypes.func.isRequired,
  unsubscribeToEvent: PropTypes.func.isRequired,
  onEventClose: PropTypes.func.isRequired,
};

export default RelatedEvent;
